import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SocialAuth from './components/SocialAuth';
import RegisterPrompt from './components/RegisterPrompt';
import LoginFooter from './components/LoginFooter';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const user = localStorage.getItem('user');
    if (user) {
      navigate('/user-dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <LoginHeader />
      
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <LoginForm />
          <SocialAuth />
          <RegisterPrompt />
        </div>
      </main>

      <LoginFooter />
    </div>
  );
};

export default LoginPage;